import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import MainServicesComponent from "./MainServicesComponent";
import Title from "/app/components/LandingPage/Title";
import useStyles from "/app/components/LandingPage/landingStyle-jss";
import { NavLink } from "react-router-dom";
import moodleIcon from "/app/images/logo/moodle.webp";
import quizIcon from "/app/images/logo/quiz-icon.webp";
import Button from "@mui/material/Button";
import vlabIcon from "/app/images/logo/vlabs.webp";
import Typography from "@mui/material/Typography";
import formServiceIcon from "/app/images/features/Forms.webp";
import vlabServiceIcon from "/app/images/features/Vitual-Labs.webp";
import digitalForumServiceIcon from "/app/images/features/Difital-Forum.webp";
import lmsServiceIcon from "/app/images/features/LMS.webp";
import contentAsseServiceIcon from "/app/images/features/content-agg.webp";
import threatServiceIcon from "/app/images/features/Assessment.webp";
import threatIcon from "/app/images/logo/awareness.webp";
import formSideImage from "/app/images/detailFeatures/isea-forms.webp";
import lmsSideIMage from "/app/images/detailFeatures/LMS.webp";
import digitalNagrik from "/app/images/detailFeatures/dig-naagriks.webp";
import vlabsSideImage from "/app/images/detailFeatures/virtual-labs.webp";
import contentAsseSideImage from "/app/images/detailFeatures/ASSESSMENT.webp";
import digitalForumSideImage from "/app/images/detailFeatures/ciso.webp";
import digiNagresources from "/app/images/features/dig-naagriks.webp";
import ideationresources from "/app/images/features/ideation.webp";
import cisoResourcesIcon from "/app/images/features/Ciso.webp";
import cisoSideImage from "/app/images/detailFeatures/ciso.webp";
import Tooltip from "@mui/material/Tooltip";
import { userLogin } from "../../../Services/UserUtil";
import AOS from "aos";
import "aos/dist/aos.css";
import "./mainservices.css";
import ResourcesMain from "../Resources/ResourcesMain";

const MainServices = (props) => {
  const tabItems = [
    {
      id: 1,
      title: "Forms",
      name: "raas",
      //   icon: moodleIcon,
      label: "Services",
      logo: moodleIcon,
      image: formServiceIcon,
      sideImage: formSideImage,
      url: `https://vlab.iseapmu.in`,
      content:
        "Forms creation will be made easy. Easily create different types of forms, like online sessions, workshops registration, giving feedback, or answering surveys, is now super easy!",
      features: `
        <ul>
        <li>Create forms through Drag and Drop Fields.</li>
        <li>Configure form publish, no.of submissions and closing dates.</li>
        <li>Share forms with others via link or sharing the links on social media.</li>
        <li>Clone your forms to reuse the template.</li>
      </ul>`,
    },

    {
      id: 2,
      title: "Learning Management System",
      name: "lms",
      logo: moodleIcon,
      image: lmsServiceIcon,
      sideImage: lmsSideIMage,
      label: "Services",
      url: "https://lms.iseapmu.in",
      icon: "tabitem__icon fas fa-network-wired",
      content:
        "LMS application intended to manage, create, and deliver online training programs.",
    },
    {
      id: 3,
      title: "Virtual Labs",
      name: "vlab",
      label: "Services",
      logo: vlabIcon,
      image: vlabServiceIcon,
      sideImage: vlabsSideImage,
      url: "vlab.iseapmu.in",
      icon: "tabitem__icon fas fa-money-check-alt",
      content:
        "The Virtual Labs web application is intended to provide Labs virtually to users. By using this application the user can reserve slot and go through lab",
    },
    {
      id: 4,
      title: "Assessment & Training",
      name: "asses_train",
      label: "Services",
      logo: threatIcon,
      image: threatServiceIcon,
      sideImage: contentAsseSideImage,
      url: "quiz.iseapmu.in",
      icon: "tabitem__icon fas fa-money-check-alt",
      content:
        "Virtual labs enable students to perform many experiments that are difficult to perform in real laboratories because of the risks.A larger variety of lab experiments can be offered remotely.",
    },
    {
      id: 5,
      title: "Digital Forum",
      name: "quiz",
      //   icon: quizIcon,
      label: "Services",
      logo: quizIcon,
      image: digitalForumServiceIcon,

      content:
        "Interactive Learning and Gaming through a Quiz Platform empowers users to both create their own quizzes and Capture The Flag (CTF) challenges, as well as participate in a wide range of quizzes and CTF events, fostering knowledge-sharing and competitive engagement.",
    },
    {
      id: 6,
      title: "Content Aggregation Platform",
      name: "ciso",
      logo: moodleIcon,
      image: contentAsseServiceIcon,
      label: "Services",
      icon: "tabitem__icon fas fa-network-wired",
      content:
        "Program to generate highly skilled Cyber Security Professionals",
    },
    {
      id: 7,
      title: "Content Aggregation Platform",
      name: "ciso",
      logo: moodleIcon,
      image: digiNagresources,
      sideImage: digitalNagrik,
      label: "Resources",
      icon: "tabitem__icon fas fa-network-wired",
      content:
        "Program to generate highly skilled Cyber Security Professionals",
    },
    {
      id: 8,
      title: "Content Aggregation Platform",
      name: "ciso",
      logo: moodleIcon,
      image: ideationresources,
      label: "Resources",
      icon: "tabitem__icon fas fa-network-wired",
      content:
        "Program to generate highly skilled Cyber Security Professionals",
    },
    {
      id: 9,
      title: "Content Aggregation Platform",
      name: "ciso",
      logo: moodleIcon,
      image: cisoResourcesIcon,
      label: "Resources",
      sideImage: cisoSideImage,
      icon: "tabitem__icon fas fa-network-wired",
      content:
        "Program to generate highly skilled Cyber Security Professionals",
    },
  ];

  const colorMap = {
    raas: "#56cbe9",
    quiz: "#ca99ff",
    lms: "#0d108ba6",
    vlab: "#918cdc",
    lmsn: "#0d6e66",
    vlabn: "#0276b0",
  };

  const { slideMode } = props;
  const { classes, cx } = useStyles();
  const [active, setActive] = useState(1);
  const scrollRef = useRef();

  const getBackgroundColor = (active) => {
    return colorMap[active] || "defaultColor";
  };

  const backgroundColor = getBackgroundColor(active);

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const handleBackToTopClick = () => {
    window.scrollTo({
      top: 5,
      behavior: "smooth",
    });
  };
  const callLogin = () => {
    userLogin();
  };

  return (
    <div className="wrapperTab section-features py-5">
      <Title
        title="Services "
        desc="Integrate all your services  at one platform"
        align="center"
        monocolor={slideMode && true}
      />
      {/* <div className="tabsTab ">
        {tabItems.map(
          ({ id, icon, title, logo, name, image, sideImage }, index) => (
            <div key={id} >
              <MainServicesComponent
                key={id}
                icon={icon}
                logo={logo}
                title={title}
                image={image}
                sideImage={sideImage}
                name={name}
                onItemClicked={() => setActive(id)}
                isActive={active === id}
                scrollRef={scrollRef}
              />
            </div>
          )
        )}
      </div> */}
      <div className="d-flex flex-column flex-wrap">
        <div className="tabsTab services-tab-list">
          {tabItems
            .slice(0, 6)
            .map(({ id, icon, title, logo, name, image, sideImage }, index) => (
              <MainServicesComponent
                key={id}
                icon={icon}
                logo={logo}
                title={title}
                image={image}
                sideImage={sideImage}
                name={name}
                onItemClicked={() => setActive(id)}
                isActive={active === id}
                scrollRef={scrollRef}
                data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}
              />
            ))}
        </div>
        <div className="tabsTab resources-tab-list flex-column">
          <div className="text-center mb--2">
            <Title
              title=" Resources"
              // desc="Integrate all your services & resources at one platform"
              align="center"
              monocolor={slideMode && true}
            />
          </div>
          <div className="d-flex  justify-content-center">
            {tabItems
              .slice(6)
              .map(
                ({ id, icon, title, logo, name, image, sideImage }, index) => (
                  <MainServicesComponent
                    key={id}
                    icon={icon}
                    logo={logo}
                    title={title}
                    image={image}
                    sideImage={sideImage}
                    name={name}
                    onItemClicked={() => setActive(id)}
                    isActive={active === id}
                    scrollRef={scrollRef}
                    data-aos={id % 2 === 0 ? "fade-left" : "fade-right"}
                  />
                )
              )}
          </div>
        </div>
      </div>
      <div className="content-border-01">
        {/* <ResourcesMain /> */}
        <div
          className="content rect content-border-11"
          style={{ backgroundColor: backgroundColor }}
        >
          <div
            className="no-content-border1 pt-5 button-position"
            ref={scrollRef}
          >
            {tabItems.map(({ id, content, features, sideImage, url }) => {
              return active === id ? (
                <div key={id}>
                  {sideImage ? (
                    <div data-aos="fade-up">
                      <img src={sideImage} width="95%" />
                    </div>
                  ) : (
                    <div className=" comingSoonText">
                      <p>Coming Soon...</p>
                    </div>
                  )}
                  {sideImage && (
                    <div className=" align-items-center useless-buttons">
                      <div className="feature-home-btn">
                        {/* <NavLink exact to="/home"> */}

                        {/* <Button
                          variant="contained"
                          color="primary"
                          onClick={handleBackToTopClick}
                        >
                          Home
                        </Button> */}
                        {/* </NavLink> */}
                      </div>
                      <div className="feature-register-btn">
                        {/* <NavLink exact to="/otp_registration">
                          <Button variant="contained" color="primary">
                            Register
                          </Button>
                        </NavLink> */}
                      </div>
                      <div className="feature-login-btn">
                        {/* <Button
                          variant="contained"
                          color="primary"
                          onClick={callLogin}
                        >
                          Login
                        </Button> */}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                ""
              );
            })}
            <Tooltip title="Back to top" placement="top">
              <div className="back-to-top mt-1">
                <button onClick={handleBackToTopClick}>
                  <i className="fa fa-long-arrow-up"></i>
                </button>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainServices;
